import { z } from "zod";

const ThreadReferenceSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
  agentId: z.string(),
  agentName: z.string(),
});

export const AgentThreadExecutionSchema = z.object({
  status: z.string().nullable(),
  parent: ThreadReferenceSchema.nullable(),
  root: ThreadReferenceSchema,
  children: z.array(
    ThreadReferenceSchema.extend({
      status: z.string().nullable(),
      startedAt: z.string(),
      /** When its result reached this thread; null until then. */
      deliveredAt: z.string().nullable(),
    }),
  ),
});

export type AgentThreadExecution = z.infer<typeof AgentThreadExecutionSchema>;

export function agentThreadReferenceLabel(reference: AgentThreadExecution["root"]): string {
  const name = reference.agentName.trim();
  const title = reference.title?.trim();
  return title && title !== name ? `${name} · ${title}` : name;
}
